import { Component, OnInit } from "@angular/core";
import { StationBlockAlertUpdateRequest } from "../../shared/station-block-alert-update-request";
import * as moment from "moment";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_BlockListSetup } from "../../shared/data.service";

@Component({
	selector: "app-update-station-block-alert",
	templateUrl: "./update-station-block-alert.component.html",
	styleUrls: ["./update-station-block-alert.component.css"],
})
export class UpdateStationBlockAlertComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private dataService: DataService_BlockListSetup,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolFullName;

		console.log(this.dialogConfig.data);

		this.SelectedStationBlockAlert = this.dialogConfig.data.SelectedStationBlockAlert;
		this.Message = this.SelectedStationBlockAlert.Message;
		this.DateRangeID = Number(this.SelectedStationBlockAlert.DateRangeID);

		var psDate = new Date(this.SelectedStationBlockAlert.StartDate);
		if (String(psDate).toLowerCase().indexOf("invalid") == -1) {
			this.StartDate = psDate;
		}

		var peDate = new Date(this.SelectedStationBlockAlert.EndDate);
		if (String(peDate).toLowerCase().indexOf("invalid") == -1) {
			this.EndDate = peDate;
		}

		this.TimeRangeID = Number(this.SelectedStationBlockAlert.TimeRangeID);

		var psTime = new Date(this.SelectedStationBlockAlert.StartTime);
		if (String(psTime).toLowerCase().indexOf("invalid") == -1) {
			this.StartTime = psTime;
		} else {
			this.StartTime = new Date();
		}

		var peTime = new Date(this.SelectedStationBlockAlert.EndTime);
		if (String(peTime).toLowerCase().indexOf("invalid") == -1) {
			this.EndTime = peTime;
		} else {
			this.EndTime = new Date();
		}

		this.PriorityID = this.SelectedStationBlockAlert.Priority;
		this.Active = this.SelectedStationBlockAlert.Active;
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	SelectedStationBlockAlert: any;

	SelectedSchool: any;
	SchoolName: string = "";

	Message: string = "";

	DateRangeID: number = 1;
	lstDateRange: any = [
		{
			ID: 1,
			Desc: "Every Day",
		},
		{
			ID: 2,
			Desc: "Date Range",
		},
		{
			ID: 3,
			Desc: "Block after",
		},
		{
			ID: 4,
			Desc: "Block until",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	TimeRangeID: number = 1;
	lstTimeRange: any = [
		{
			ID: 1,
			Desc: "Block All Day",
		},
		{
			ID: 2,
			Desc: "Block During Time Range",
		},
		{
			ID: 3,
			Desc: "Block After (Ex. Can't enter after-school program)",
		},
		{
			ID: 4,
			Desc: "Block Before (Ex. Night students can't enter during the day)",
		},
	];

	StartTime: Date = new Date();
	EndTime: Date = new Date();

	PriorityID: number = 1;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];

	Active: boolean = false;

	Processing: boolean = false;
	errorMessage: string = "";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		var fsDate = "";
		var feDate = "";

		if (this.DateRangeID == 2 || this.DateRangeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		}
		if (this.DateRangeID == 2 || this.DateRangeID == 4) {
			feDate = moment(this.EndDate).format("MM/DD/YYYY");
		}

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Date";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Date";
			return;
		}

		var fsTime = "";
		var feTime = "";

		if (this.TimeRangeID == 2 || this.TimeRangeID == 3) {
			fsTime = moment(this.StartTime).format("HH:mm:00");
		}
		if (this.TimeRangeID == 2 || this.TimeRangeID == 4) {
			feTime = moment(this.EndTime).format("HH:mm:00");
		}

		if (String(fsTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Time";
			return;
		}
		if (String(feTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Time";
			return;
		}

		// Block After
		if (this.TimeRangeID == 3) {
			feTime = "23:59:59";
		}
		// Block Before
		else if (this.TimeRangeID == 4) {
			fsTime = "00:00:00";
		}

		this.Processing = true;

		var parms: StationBlockAlertUpdateRequest = {
			StationBlockAlertID: this.SelectedStationBlockAlert.StationBlockAlertID,
			SchoolID: this.SelectedSchool.SchoolID,
			Message: this.Message,
			StartDate: fsDate,
			EndDate: feDate,
			StartTime: fsTime,
			EndTime: feTime,
			Priority: this.PriorityID,
			Active: this.Active,
		};

		var result = this.dataService.StationBlockAlertUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalertedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Block List was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalertedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Block List: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	//////////////////////////////////////////////////////////
}
